<template>
    <h1 id="title">{{title}}</h1>
</template>

<script>
export default {
    data(){
        return {
            title: 'Mis Cursos'
        }
    }
}
</script>

<style>
   
</style>



// WEBPACK FOOTER //
// src/components/courses/myCourses/courseTitle.vue